
export default [
    {
        path: '/manage/staffTransfer',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '调店审核',
            keepAlive: false
        }
    },   
];
  